import React from 'react'
import { Stack, styled, Typography, Box } from '@mui/material'



const CustomTooltipContainer = styled(Stack)(
  ({ theme }) => `
		gap: ${theme.spacing(0.5)};
		padding: ${theme.spacing(1, 2)};
		background-color: hsla(0,0%,100%,0.8);
		backdrop-filter: blur(4px);
		font-size: 12px;
		border-radius: 8px;
		border: 1px solid ${theme.palette.grey['300']};
		box-shadow: 0px 16px 24px -8px rgba(0, 0, 0, 0.16);
		color: ${theme.palette.grey['800']};
	`,
)

const CTTitle = styled(Box)`
  font-size: 12px;
  font-weight: 500;
`

const CTColor = styled(Box)(({ color }) => {
  return `
    height: 8px;
    width: 8px;
    border-radius: 4px;
    background-color: ${color};
  `
})

const TooltipList = ({ title, list }) => {
  return (
    <CustomTooltipContainer>
      <CTTitle>{title}</CTTitle>
      <Stack gap={1}>
        {
          list.map((item, i) => (
            <Stack direction="row" gap={1} alignItems="baseline" key={i}>
              <CTColor color={item.color} />
              <Typography variant={'caption'}>{item.label}</Typography>
              <Box sx={{flexGrow: 1, justifyContent: 'end', display: 'flex'}}><Typography variant={'caption'}>{item.value}</Typography></Box>
            </Stack>
          ))
        }
      </Stack>
    </CustomTooltipContainer>
  )
}

export default TooltipList